<template>
  <div class="relative h-full w-full bg-black">
    <img
      ref="imgRef"
      v-show="showImage"
      :src="src"
      alt=""
      draggable="false"
      decoding="async"
      class="block h-full w-full object-cover object-center"
      @error="onError"
    >
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { ensureHtmlImageDecoded } from '@/helpers/imagePredecodeCache'

const props = defineProps<{
  src: string
  assetUrn: string
}>()

const imgRef = ref<HTMLImageElement | null>(null)
const showImage = ref(false)
let decodeGeneration = 0

async function decodeCurrent(): Promise<void> {
  const gen = ++decodeGeneration
  showImage.value = false
  const el = imgRef.value
  if (el == null || props.src === '') {
    return
  }
  const ok = await ensureHtmlImageDecoded(el, props.src)
  if (gen !== decodeGeneration) {
    return
  }
  showImage.value = ok && el.naturalWidth >= 64 && el.naturalHeight >= 64
}

function onError() {
  showImage.value = false
}

watch(
  () => props.src,
  () => {
    void decodeCurrent()
  },
  { immediate: true }
)

watch(imgRef, (el) => {
  if (el != null) {
    void decodeCurrent()
  }
})
</script>
